module.exports = __webpack_public_path__ + "static/media/vector-next.ddc63ce4.svg";